<template>
  <div v-if="currentTraining != null">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.videos.active-videos')}}</h3>
          </div>
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <tbody>
              <tr>
                <th v-if="!isBackoffice()">{{$t('trainings.videos.name')}}</th>
                <th v-if="isBackoffice()">{{$t('trainings.videos.name')}} [en]</th>
                <th v-if="isBackoffice()">{{$t('trainings.videos.name')}} [ru]</th>
                <th>{{$t('trainings.videos.link')}}</th>
                <th></th>
              </tr>
              <tr
                v-for="video in currentTraining.videos"
                :key="video.id"
              >
                <td v-if="!isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="video.name[$root.$i18n.locale]" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateVideo(video)" type="button" class="btn btn-info btn-flat">
                      Save
                    </button>
                  </span>
                  </div>
                </td>

                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="video.name['en']" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateVideo(video)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>
                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="video.name['ru']" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateVideo(video)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>

                <td>
                  <div class="input-group">
                    <input type="text" v-model="video.link" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateVideo(video)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>

                <td><a v-on:click="deleteVideo(video.id)"><i
                  class="text-red fa fa-times-circle-o"></i></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.videos.added-form.title')}}</h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-12">
                <div v-if="!isBackoffice()" class="form-group">
                  <label>{{$t('trainings.videos.added-form.name')}}</label>
                  <input type="text" v-model="addedVideo.name[$root.$i18n.locale]" class="form-control"
                         placeholder="">
                </div>

                <div v-if="isBackoffice()" class="form-group">
                  <label>{{$t('trainings.videos.added-form.name')}} [en]</label>
                  <input type="text" v-model="addedVideo.name['en']" class="form-control"
                         placeholder="">
                </div>
                <div v-if="isBackoffice()" class="form-group">
                  <label>{{$t('trainings.videos.added-form.name')}} [ru]</label>
                  <input type="text" v-model="addedVideo.name['ru']" class="form-control"
                         placeholder="">
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="form-group">
                        <label>{{$t('trainings.videos.added-form.link')}}</label>
                        <input type="text" class="form-control" v-model="addedVideo.link" placeholder="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <button type="submit" v-on:click="saveVideo" class="btn btn-info pull-right">
              {{$t('button.save-changes')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'TrainingVideos',
  props: {
    currentTraining: Object
  },
  data () {
    return {
      addedVideo: {
        trainingId: '',
        name: {
          ru: '',
          en: ''
        },
        link: ''
      }
    };
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    deleteVideo (videoId) {
      let self = this;

      axios.delete(
        window.host + '/trainings/' + self.currentTraining.id + '/videos/' + videoId)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.currentTraining.id);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    saveVideo () {
      let self = this;

      self.addedVideo.trainingId = self.currentTraining.id;

      let data = {
        name: self.addedVideo.name,
        link: self.addedVideo.link
      };

      axios.post(
        window.host + '/trainings/' + self.currentTraining.id + '/videos', data)

        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.currentTraining.id);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    updateVideo (video) {
      let self = this;

      video.trainingId = self.currentTraining.id;

      let savedVideo = {
        name: video.name,
        link: video.link
      };

      axios.patch(window.host + '/trainings/' + video.trainingId + '/videos/' + video.id,
        savedVideo)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>
  .modal-dialog-l {
    width: 80%;
  }

  .modal-body__photos {
    background-color: #ecf0f5;
  }

  .btn-box-tool__absolute {
    position: absolute;
    top: -3px;
    right: 0;
  }

  .photo-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .box__photo {
    width: 200px;
  }
</style>
